import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ApiCollectionState {
  items: any[];
  loading: boolean;
  error: any;
  logs: any;
  isCleared: boolean;
  isClearedFunction: any;
  parameters: any;
  authorization: any;
  reqHeaders: any;
  bodyData: any;
  currentEnvironmentVariables: any;
  reqFormDataNew: any;
  tabToDelete: string | null;
  confirmationModal: {
    item: any;
    open: boolean;
    type: "COLLECTION" | "REQUEST" | "ENVIRONMENT" | "FOLDER" | null;
    temp?: boolean;
  };
  exportModal: {
    open: boolean;
    item: any;
    type: "COLLECTION" | "ENVIRONMENT";
  };
  importModal: {
    open: boolean;
    item: any;
    type: "COLLECTION" | "ENVIRONMENT";
  };
  sendingRequest: boolean;
  savingRequest: boolean;
  readyToRunApis: boolean;
}

const initialState: ApiCollectionState = {
  items: [],
  loading: false,
  error: null,
  logs: [],
  isCleared: false,
  isClearedFunction: false,
  parameters: [],
  authorization: {},
  reqHeaders: [],
  bodyData: {},
  currentEnvironmentVariables: [],
  reqFormDataNew: [],
  tabToDelete: null,
  confirmationModal: {
    item: null,
    open: false,
    type: "REQUEST",
  },
  exportModal: {
    open: false,
    item: null,
    type: "COLLECTION",
  },
  importModal: {
    open: false,
    item: null,
    type: "COLLECTION",
  },
  sendingRequest: false,
  savingRequest: false,
  readyToRunApis: false,
};

const apiCollectionSlice = createSlice({
  name: "apiCollection",
  initialState,
  reducers: {
    setLogs: (state, action: PayloadAction<any>) => {
      state.logs = action.payload;
    },
    setParameters(state, action: PayloadAction<any>) {
      const parameters = action.payload;

      // Check if the last item exists and has a non-empty 'key' and 'value'
      const lastItem = parameters[parameters.length - 1];
      if (
        lastItem &&
        lastItem?.key?.trim() !== "" &&
        lastItem.value.trim() !== ""
      ) {
        // Add an empty object if the last item is not empty
        parameters.push({
          key: "",
          value: "",
          enabled: true,
        });
      }

      // Update the state with the modified parameters
      state.parameters = parameters;
    },

    // setResponseIdentifier(state) {
    //   state.responseIdentifier = getId();
    // },
    addLog(state, action) {
      state.logs.push(action.payload);
    },
    resetLogs(state) {
      state.logs = [];
    },
    setIsCleared(state, action: PayloadAction<any>) {
      state.isCleared = action.payload;
    },
    setIsClearedFunction(state, action: PayloadAction<any>) {
      state.isClearedFunction = action.payload;
    },
    setTabToDelete(state, action: PayloadAction<string | null>) {
      state.tabToDelete = action.payload;
    },
    setConfirmationModal(
      state,
      action: PayloadAction<{
        item: any;
        open: boolean;
        type: "COLLECTION" | "REQUEST" | "ENVIRONMENT" | "FOLDER" | null;
        temp?: boolean;
      }>
    ) {
      state.confirmationModal = action.payload;
    },
    setSendingRequest(state, action: PayloadAction<boolean>) {
      state.sendingRequest = action.payload;
    },
    setSavingRequest(state, action: PayloadAction<boolean>) {
      state.savingRequest = action.payload;
    },
    setExportModal(state, action: PayloadAction<any>) {
      state.exportModal = action.payload;
    },
    setImportModal(state, action: PayloadAction<any>) {
      state.importModal = action.payload;
    },
    setReadyToRunApis: (state, action) => {
      state.readyToRunApis = action.payload;
    },
  },
});

export const {
  setLogs,
  setParameters,
  addLog,
  resetLogs,
  setIsCleared,
  setIsClearedFunction,
  setTabToDelete,
  setConfirmationModal,
  setSendingRequest,
  setSavingRequest,
  setExportModal,
  setImportModal,
  setReadyToRunApis,
} = apiCollectionSlice.actions;

export default apiCollectionSlice.reducer;
